module.exports = __webpack_public_path__ + "static/media/SPA.06a08eb5.pdf";